import {useState} from 'react'
import { LeftMenu } from '../Policy/components/LeftMenu'
import { FileSearch } from './components/FileSearch'
// import { Medium} from './components/Medium'
import useGetThemeList from './hooks/useGetThemeList'
import util from "../../utils/utils";
import {MarkModal} from '../../components/MarkModal'
import useGetSavedFoldList from '../../hooks/useGetSavedFoldList';

export const ThinkTankAbroad = (props) => {
    const INIT_THEME_ID = -1
    // const { loading,data ,refresh,editingMenuId, setEditingMenuId,activeMenuId,setActiveMenuId} = useGetThemeList();
    // const defaultActiveMenuId =  data ? data[0]?.theme_id ?? INIT_THEME_ID : INIT_THEME_ID
    const [selectedCards,setSelectedCards] =useState([])
    const [searchId,setSearchId] =useState()
    // const [collapsed,setCollapsed] = useState(false)
    const [input,setInput] =useState('')
    const [markData, setMarkData] = useState()
    const {savedFoldListLoading, savedFoldListData, savedFoldListRefresh} = useGetSavedFoldList()

    return (
        <>
            <MarkModal
                markData={markData}
                loading={savedFoldListLoading}
                data={savedFoldListData}
                savedFoldListRefresh={savedFoldListRefresh}
            />
            {/* <LeftMenu
                loading={loading}
                data={data}
                refresh={refresh}
                activeMenuId={activeMenuId ? activeMenuId : defaultActiveMenuId}
                setActiveMenuId={setActiveMenuId}
                editingMenuId={editingMenuId}
                setEditingMenuId={setEditingMenuId}
                INIT_THEME_ID={INIT_THEME_ID}
            /> */}
            <div className='flex-1 flex'>
                <FileSearch
                    // activeMenuId={activeMenuId ? activeMenuId : defaultActiveMenuId}
                    // menuRefresh={refresh}
                    selectedCards={selectedCards}
                    setSelectedCards={setSelectedCards}
                    // setActiveMenuId={setActiveMenuId}
                    INIT_THEME_ID={INIT_THEME_ID}
                    setSearchId={setSearchId}
                    searchId={searchId}
                    input={input}
                    setInput={setInput}
                    setMarkData={setMarkData}
                    savedFoldListData={savedFoldListData}
                />
                {/* <Medium
                    activeMenuId={activeMenuId ?? defaultActiveMenuId}
                    INIT_THEME_ID={INIT_THEME_ID}
                    searchId={searchId}
                    selectedCards={selectedCards}
                    collapsed={collapsed}
                    setCollapsed={setCollapsed}
                    input={input}
                /> */}
            </div>
        </>
    )
}

